import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timesheet-filter',
  templateUrl: './timesheet-filter.component.html',
  styleUrls: ['./timesheet-filter.component.css']
})
export class TimesheetFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
